import api from '@/api/locations';
import store from '@/store/store';

const fetchLocations = (context, criteria) => new Promise(((resolve, reject) => {
  api.fetchLocations(criteria.siteId, criteria.pageIndex, criteria.orderInfo)
    .then((response) => {
      resolve(response);
      store.commit('locations/storeLocationList', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const fetchLocation = (context, criteria) => new Promise(((resolve, reject) => {
  api.fetchLocation(criteria.partnerId, criteria.siteId, criteria.id)
    .then((response) => {
      resolve(response);
      store.commit('locations/storeLocation', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const updateLocation = (context, criteria) => new Promise(((resolve, reject) => {
  api.updateLocation(criteria.partnerId, criteria.siteId, criteria.id, criteria.params)
    .then((response) => {
      resolve(response);
      store.commit('locations/storeUpdatedLocation', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const createLocation = (context, criteria) => new Promise(((resolve, reject) => {
  api.createLocation(criteria.siteId, criteria.params)
    .then((response) => {
      resolve(response);
      store.commit('locations/storeCreatedLocation', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const deleteLocation = (context, criteria) => new Promise(((resolve, reject) => {
  api.deleteLocation(criteria.partnerId, criteria.siteId, criteria.id)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

export default {
  fetchLocations,
  fetchLocation,
  updateLocation,
  createLocation,
  deleteLocation,
};




// WEBPACK FOOTER //
// ./src/store/modules/locations/actions.js